import { reactive } from "vue"

export const LOCAL_STORAGE_KEY = "tiodomin_home_cache"
export const LOCAL_STORAGE_ADMIN_KEY = "tiodomin_admin_cache"
const CACHE_KEY_LIMIT = 15

function loadCacheFromStorage() {
    try {
        const raw = localStorage.getItem(LOCAL_STORAGE_KEY)
        if (raw) {
            return JSON.parse(raw)
        }
    } catch (e) {
        console.log(e)
    }
    return {}
}

function saveCacheToStorage(cache: Record<string, any>) {
    try {
        localStorage.setItem(LOCAL_STORAGE_KEY, JSON.stringify(cache))
    } catch (e) {
        console.log(e)
    }
}

const cache = reactive<Record<string, any>>(loadCacheFromStorage())

export function useCacheStore() {
    return {
        get(key: string) {
            return cache[key]
        },
        set(key: string, value: any, autoCleanKey?: string) {
            if (autoCleanKey && key.startsWith(autoCleanKey)) {
                const cacheData = loadCacheFromStorage()
                const keysMatched = Object.keys(cacheData).filter((i) =>
                    i.startsWith(autoCleanKey)
                )
                if (keysMatched.length >= CACHE_KEY_LIMIT) {
                    keysMatched.forEach((item, index) => {
                        if (index >= CACHE_KEY_LIMIT) {
                            this.clear(item)
                        }
                    })
                }
            }
            cache[key] = value
            saveCacheToStorage(cache)
        },
        clear(key?: string) {
            if (key) {
                delete cache[key]
                saveCacheToStorage(cache)
            } else {
                Object.keys(cache).forEach((k) => delete cache[k])
                localStorage.removeItem(LOCAL_STORAGE_KEY)
            }
        },
        cleanAll(key: string = LOCAL_STORAGE_KEY) {
            Object.keys(cache).forEach((k) => delete cache[k])
            localStorage.removeItem(key)
        },
    }
}
